import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import enhance from './CompanyProfile.enhancer';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import StarsIcon from '@material-ui/icons/Stars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import PersonIcon from '@material-ui/icons/Person';
import DomainIcon from '@material-ui/icons/Domain';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import ItemsCarousel from 'react-items-carousel';
import { filter, uniqBy } from 'lodash';
import { dealStatuses, campaignStatuses } from '../../../constants';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import StarRatings from 'react-star-ratings';
import LinkText from '../../shared/components/LinkText';

class CompanyProfile extends React.Component {
  constructor() {
    super();
    const initialState = {
      currentActiveCampaign: 0,
      currentActiveProduct: 0,
      completedDealRows: [],
      profile: {},
      completedDeals: [],
      completedDealsCount: 0,
      matchCount: 0,
      rating: 0,
      ratings: [],
      ratingsCount: 0,
      campaigns: [],
      activeCampaigns: [],
      products: [],
      dealsLoaded: false,
      campaignsLoaded: false,
      ratingsLoaded: false,
      count: 0,
      currentPage: 0,
      numberOfCards: this.currentWidth()
    };

    this.state = {
      ...initialState
    };
  }

  setActiveCampaign = value => {
    this.setState({
      ...this.state,
      currentActiveCampaign: value
    });
  };

  setActiveProduct = value => {
    this.setState({
      ...this.state,
      currentActiveProduct: value
    });
  };

  navigateToCampaign = campaignId => {
    this.props.history.push(`/campaigns/${campaignId}`);
  };

  componentWillReceiveProps(nextProps) {
    const currentUid = this.props.userId;
    const nextuid = nextProps.userId;
    if (currentUid !== nextuid) {
      this.loadData(nextProps.userId);
    }
  }

  componentDidMount() {
    this.loadData(this.props.userId);

    window.addEventListener(
      'resize',
      () => {
        const numberOfCards = this.currentWidth();
        if (this.state.numberOfCards !== numberOfCards) {
          this.setState({
            numberOfCards: numberOfCards
          });
        }
      },
      false
    );
  }

  currentWidth() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 800) numberOfCards = 2;
    else if (window.innerWidth < 1280) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  loadData(userId) {
    // get profile from userId
    this.props.firestore
      .get({
        collection: 'users',
        doc: userId
      })
      .then(user => {
        const userData = user.data();
        if (userData) {
          this.setState({
            profile: userData,
            products: userData.products
          });
        }
      });

    // get deals
    this.props.firestore
      .get({
        collection: 'deals',
        where: [['companyId', '==', userId]],
        storeAs: 'profileDeals'
      })
      .then(dealSnaps => {
        if (dealSnaps.docs.length) {
          const deals = dealSnaps.docs.map(deal => {
            return {
              ...deal.data(),
              id: deal.id
            };
          });

          const completedDeals = filter(
            deals,
            deal => deal.status === dealStatuses.COMPLETE
          );
          const completedDealsCount = completedDeals.length;
          const matchCount = uniqBy(deals, deal => deal.influencerId).length;

          this.setState({
            ...this.state,
            deals,
            completedDeals,
            completedDealsCount,
            matchCount,
            dealsLoaded: true
          });

          this.createCompletedDealTableRows();
        }
      });

    // get campaigns
    this.props.firestore
      .get({
        collection: 'campaigns',
        storeAs: 'profileCampaigns',
        where: [['creator', '==', userId]]
      })
      .then(campaignsSnaps => {
        if (campaignsSnaps.docs.length) {
          const campaigns = campaignsSnaps.docs.map(camp => {
            return {
              ...camp.data(),
              id: camp.id
            };
          });
          const activeCampaigns = filter(
            campaigns,
            camp => camp.status === campaignStatuses.ACTIVE
          );
          this.setState({
            ...this.state,
            campaigns,
            activeCampaigns,
            campaignsLoaded: true
          });
          this.createCompletedDealTableRows();
        }
      });

    // get ratings
    this.props.firestore
      .get({
        collection: 'ratings',
        where: [['ratedUser', '==', userId]]
      })
      .then(ratingSnaps => {
        if (ratingSnaps.docs.length) {
          const ratings = ratingSnaps.docs.map(rating => {
            return {
              ...rating.data(),
              id: rating.id
            };
          });

          let rating = 5;
          if (ratings && ratings.length) {
            let total = 0;
            ratings.forEach(rating => {
              total = total + rating.rating;
            });

            rating = total / ratings.length;
          }

          this.setState({
            ...this.state,
            ratings,
            rating,
            ratingsCount: ratings.length,
            ratingsLoaded: true
          });
        } else {
          this.setState({
            ...this.state,
            ratingsLoaded: true
          });
        }
        this.createCompletedDealTableRows();
      });
  }

  createCompletedDealTableRows() {
    if (
      this.state.dealsLoaded &&
      this.state.campaignsLoaded &&
      this.state.ratingsLoaded
    ) {
      const completedDeals = this.state.completedDeals;
      const campaigns = this.state.campaigns;
      const ratings = this.state.ratings;

      const rows = completedDeals.slice(0, 5).map(deal => {
        const date = deal.currentProposal.dueDate.toDate();
        const dueDate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;

        const matchedCampaign = find(
          campaigns,
          camp => camp.id === deal.campaignId
        );
        const matchedRating = find(
          ratings,
          rating => rating.dealId === deal.id
        );
        return {
          ...deal,
          campaignName: matchedCampaign ? matchedCampaign.name : '',
          campaignId: matchedCampaign ? matchedCampaign.id : '',
          dueDateString: dueDate,
          rating: matchedRating ? matchedRating.rating : ''
        };
      });

      this.setState({
        ...this.state,
        completedDealRows: rows
      });
    }
  }

  handleChangePage(event, newPage) {
    const rowStart = newPage * 10;
    this.setState({
      currentPage: newPage,
      tableRows: this.state.completedDeals.slice(rowStart, rowStart + 10)
    });
  }

  render() {
    const { classes } = this.props;

    const {
      currentActiveCampaign,
      currentActiveProduct,
      completedDealRows,
      profile,
      completedDeals,
      completedDealsCount,
      matchCount,
      rating,
      ratings,
      ratingsCount,
      campaigns,
      activeCampaigns,
      products,
      count,
      currentPage,
      numberOfCards
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <Grid container direction="column" spacing={8}>
            <Grid
              item
              container
              xs={12}
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <img
                  src={profile.profilePictureUrl}
                  className={classes.circleImage}
                />
              </Grid>
              <Grid
                item
                xs
                container
                direction="column"
                justify="center"
                spacing={2}
              >
                <Grid item>
                  <Typography variant="h5">{profile.displayName}</Typography>
                </Grid>
                <Grid item container spacing={2}>
                  <Grid item>
                    <div className={classes.profileStatsContainer}>
                      <Typography>
                        {completedDealsCount} Deals Completed
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item>
                    <div className={classes.profileStatsContainer}>
                      <Typography>{matchCount} Followers</Typography>
                    </div>
                  </Grid>
                  <Grid item>
                    <div className={classes.profileStatsContainer}>
                      <div className={classes.rating}>
                        <StarRatings
                          rating={rating}
                          starRatedColor="#22c26e"
                          starDimension="1rem"
                          starSpacing={2}
                          name="rating"
                        />
                      </div>
                      <Typography> ({ratingsCount})</Typography>
                    </div>
                  </Grid>
                </Grid>
                <Grid className={classes.interestContainer}>
                  {profile &&
                    profile.interests &&
                    profile.interests
                      .slice(0, 3)
                      .map((interest, index) => (
                        <span className={classes.interest}>{interest}</span>
                      ))}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.subTitle} variant="h5">
                Interested In
              </Typography>
              <Grid container direction="row" alignItems="stretch" spacing={2}>
                <Grid item>
                  <div className={classes.interestItem}>
                    <Grid
                      container
                      spacing={2}
                      direction="column"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography align="center" variant="h6">
                          Platform
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Fab color="secondary" aria-label="youtube">
                          <FontAwesomeIcon
                            className={`${classes.icon} ${classes.youtubeIcon}`}
                            icon={faYoutube}
                          />
                        </Fab>
                      </Grid>
                      <Grid item>
                        <Typography align="center">Youtube</Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item>
                  <div className={classes.interestItem}>
                    <Grid
                      container
                      spacing={2}
                      direction="column"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography align="center" variant="h6">
                          Influencers
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Fab color="primary" aria-label="youtube">
                          <PersonIcon
                            className={`${classes.icon} ${classes.youtubeIcon}`}
                          />
                        </Fab>
                      </Grid>
                      <Grid item>
                        <Typography align="center">
                          {profile.targetAudience}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item>
                  <div className={classes.interestItem}>
                    <Grid
                      container
                      spacing={2}
                      direction="column"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography align="center" variant="h6">
                          Industry
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Fab
                          className={classes.industryIconButton}
                          aria-label="youtube"
                        >
                          <DomainIcon
                            className={`${classes.icon} ${classes.industryIcon}`}
                          />
                        </Fab>
                      </Grid>
                      <Grid item>
                        <Typography align="center">
                          {profile.industry}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item>
                  <div className={classes.interestItem}>
                    <Grid
                      container
                      spacing={2}
                      direction="column"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography align="center" variant="h6">
                          Level of Influence
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Fab
                          className={classes.levelIconButton}
                          aria-label="youtube"
                        >
                          <WhatshotIcon
                            className={`${classes.icon} ${classes.levelIcon}`}
                          />
                        </Fab>
                      </Grid>
                      <Grid item>
                        <Typography align="center">
                          {profile.levelOfInfluence}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.subTitle}>
                Active Campaigns
              </Typography>
              <Grid item container>
                <div style={{ padding: '0 60px', width: '100%' }}>
                  <ItemsCarousel
                    gutter={12}
                    activePosition={'center'}
                    chevronWidth={40}
                    numberOfCards={numberOfCards}
                    outsideChevron={true}
                    showSlither={false}
                    firstAndLastGutter={false}
                    activeItemIndex={currentActiveCampaign}
                    requestToChangeActive={this.setActiveCampaign.bind(this)}
                    rightChevron={
                      <IconButton color="primary">
                        <ArrowForwardIosIcon fontSize="small" />
                      </IconButton>
                    }
                    leftChevron={
                      <IconButton color="primary">
                        <ArrowBackIosIcon fontSize="small" />
                      </IconButton>
                    }
                  >
                    {activeCampaigns &&
                      activeCampaigns.map((campaign, i) => (
                        <Grid
                          container
                          direction="column"
                          className={classes.carouselItem}
                          align="center"
                          justify="top"
                          onClick={() => this.navigateToCampaign(campaign.id)}
                          key={i}
                        >
                          {campaign.productPhotoUrl && (
                            <img
                              src={campaign.productPhotoUrl}
                              className={classes.carouselBottomImage}
                            />
                          )}
                          {!campaign.productPhotoUrl && (
                            <img
                              src="/images/no-product-image.png"
                              className={classes.carouselBottomImage}
                            />
                          )}
                          <Grid item className={classes.carouselBottom}>
                            <Typography className={classes.camapignLink}>
                              {campaign.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      ))}
                  </ItemsCarousel>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.subTitle} variant="h5">
                Products
              </Typography>
              {products && products.length > 0 && (
                <Grid container direction="row">
                  <div style={{ padding: '0 60px', width: '100%' }}>
                    <ItemsCarousel
                      gutter={12}
                      activePosition={'center'}
                      chevronWidth={40}
                      numberOfCards={numberOfCards}
                      outsideChevron={true}
                      showSlither={false}
                      firstAndLastGutter={false}
                      activeItemIndex={currentActiveProduct}
                      requestToChangeActive={this.setActiveProduct.bind(this)}
                      rightChevron={
                        <IconButton color="primary">
                          <ArrowForwardIosIcon fontSize="small" />
                        </IconButton>
                      }
                      leftChevron={
                        <IconButton color="primary">
                          <ArrowBackIosIcon fontSize="small" />
                        </IconButton>
                      }
                    >
                      {products.map((product, i) => (
                        <Grid
                          container
                          direction="column"
                          className={classes.productCarouselItem}
                          align="center"
                          justify="top"
                          key={i}
                        >
                          {product.productPhotoUrl && (
                            <img
                              src={product.productPhotoUrl}
                              className={classes.carouselBottomImage}
                            />
                          )}
                          {!product.productPhotoUrl && (
                            <img
                              src="/images/no-product-image.png"
                              className={classes.carouselBottomImage}
                            />
                          )}
                          <Grid item className={classes.carouselBottom}>
                            {product.productName}
                          </Grid>
                        </Grid>
                      ))}
                    </ItemsCarousel>
                  </div>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12} container direction="column">
              <Typography variant="h5" className={classes.subTitle}>
                Recent Deals
              </Typography>
              <Grid item xs={12}>
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.headerCell}>
                          Date
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Campaign Title
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                          Rating
                        </TableCell>
                      </TableRow>
                      {completedDealRows &&
                        completedDealRows.length > 0 &&
                        completedDealRows.map((row, i) => (
                          <TableRow key={i} className={classes.tableRow}>
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tableCell}
                            >
                              {row.dueDateString}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tableCell}
                            >
                              <LinkText
                                className={classes.camapignLink}
                                onClick={completedDeal =>
                                  this.navigateToCampaign(row.campaignId)
                                }
                              >
                                {row.campaignName}
                              </LinkText>
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className={classes.tableCell}
                            >
                              <StarRatings
                                rating={Number(row.rating)}
                                starRatedColor="#22c26e"
                                starDimension="1.25rem"
                                starSpacing={2}
                                name="rating"
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      {(!completedDealRows || !completedDealRows.length) && (
                        <TableRow>
                          <TableCell colSpan={5}>
                            <Typography align="center" variant="h6">
                              No Completed Deals
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={count}
                    rowsPerPage={10}
                    page={currentPage}
                    backIconButtonProps={{
                      'aria-label': 'Previous Page'
                    }}
                    nextIconButtonProps={{
                      'aria-label': 'Next Page'
                    }}
                    onChangePage={this.handleChangePage.bind(this)}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </main>
      </React.Fragment>
    );
  }
}

export default enhance(CompanyProfile);



// WEBPACK FOOTER //
// ./src/components/company/profile/CompanyProfile.js